import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Container,
  Button,
  Grid,
  CircularProgress,
} from "@mui/material";
import BlogCart from "../../../Components/BlogCart";
import BlogSearchBar from "./BlogSearchBar";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";
import { useGetAllBlogsQuery } from "../../../Store/api/rtk";
import CustomPagination from "../../../Components/CustomPagination";

// Theme config
const darkTheme = {
  green: "#12C895",
  greenLow: "rgba(18, 200, 149, 0.05)",
  glassBg: "rgba(20, 26, 36, 0.6)",
  borderRaw: "rgba(255, 255, 255, 0.06)",
  textWhite: "#F8FAFC",
  textMuted: "#94A3B8",
};

export default function Blogs() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);

  const { data, status } = useGetAllBlogsQuery({ search: searchQuery });
  const blogs = data?.data?.data || [];

  // Render blog list
  const blogItems = blogs?.map((blog) => (
    <Grid size={{ xs: 12, md: 6, lg: 4 }} sx={{ p: "1rem" }} key={blog?.code}>
      <BlogCart blog={blog} />
    </Grid>
  ));

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "transparent",
        color: darkTheme?.textWhite,
        py: { xs: 4, md: 10 },
        minHeight: "100vh",
        "& *": { direction: "rtl", boxSizing: "border-box" },
      }}
    >
      <Container maxWidth={"xl"} sx={{ px: { xs: 2, md: 5 } }}>

        {/* Header */}
        <Stack spacing={2} alignItems="center" mb={7}>
          <Stack direction="row" gap={1} alignItems="center">
            <Typography
              sx={{
                fontSize: ".85rem",
                letterSpacing: 4,
                color: darkTheme?.green,
                fontFamily: "monospace",
              }}
            >
              // BLOG_ARCHIVE
            </Typography>
          </Stack>

          <Typography
            component="h1"
            sx={{
              color: darkTheme?.textWhite,
              fontWeight: 900,
              textAlign: "center",
              lineHeight: 1.3,
              fontSize: { xs: "1.8rem", md: "2.8rem" },
            }}
          >
            مقالات <span style={{ color: darkTheme?.green }}>آموزشی</span>
          </Typography>

          <Typography
            sx={{
              color: darkTheme?.textMuted,
              textAlign: "center",
              maxWidth: 700,
              lineHeight: 2,
              fontSize: { xs: "0.9rem", md: "1rem" },
            }}
          >
            جدیدترین آموزش‌ها، مقالات تخصصی و نکات حرفه‌ای آرایش، مراقبت پوست و
            دنیای زیبایی.
          </Typography>

          <BlogSearchBar
            search={searchQuery}
            onSearch={(value) => {
              setSearchQuery(value);
              setPage(1);
            }}
          />
        </Stack>

        {/* Blog Grid */}
        <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={3}>
          {status !== "fulfilled" ? (
            <Stack
              sx={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                py: "4rem",
              }}
            >
              <CircularProgress sx={{ color: darkTheme?.green }} />
            </Stack>
          ) : blogs?.length > 0 ? (
            <Grid sx={{ width: "100%" }} container>
              {blogItems}
            </Grid>
          ) : (
            <Typography
              sx={{
                py: 10,
                color: darkTheme?.textMuted,
                fontFamily: "monospace",
              }}
            >
              [NO_DATA_FOUND]
            </Typography>
          )}
        </Stack>

        {/* Pagination */}
        <Stack alignItems="center" mt={{ xs: 7, md: 9 }}>
          <CustomPagination
            count={data?.num_of_pages}
            page={page}
            setPage={setPage}
          />
        </Stack>
      </Container>
    </Box>
  );
}
